module.exports = __webpack_public_path__ + "static/img/knowledge-unlatched.fc44e18c.svg";